export const getOtherSrcToCityInterlinkingBlocks = (otherSourceToCity, cityName: string) => {
  return {
    title: otherSourceToCity.title,
    format: otherSourceToCity.format,
    list: otherSourceToCity.list.map((value) => ({
      source: value.source,
      destination: cityName,
      link: value.routePageUrl
    }))
  };
};

export const getOtherDestFromCityInterlinkingBlocks = (OtherDestinationToCity, cityName: string) => {
  return {
    title: OtherDestinationToCity.title,
    format: OtherDestinationToCity.format,
    list: OtherDestinationToCity.list.map((value) => ({
      source: cityName,
      destination: value.destination,
      link: value.routePageUrl
    }))
  };
};
